<template>
  <section class="plan-info-container">
    <div class="card">
      <span class="company-logo">
        <img
          :src="formData.company_logo"
          alt="company" />
      </span>
      <span class="label">{{ formData.plan }}</span>
      <!-- <span
        class="label"
      >{{ getOptionName('classOptions', formData.class_id) }} Insurance {{ getOptionName('coverTypeOptions', formData.trm_of_cvr) }} Plan</span> -->
      <v-button
        type="info"
        @click="planClick">Plan Info</v-button>
      <plan-quote-info :formData="formData.quote_coverage_list" />
      <!-- <div class="table">
        <div class="tr">
          <span>Basic Premium</span>
          <span>{{ formData.pre_basic_prm | value | formatMoney }}</span>
        </div>
        <div class="tr">
          <span>NCD</span>
          <span>{{ formData.ncd_vl | value | formatMoney }}</span>
        </div>
        <div class="tr">
          <span>MGM Discount {{ formData.code_disc_pct }}%</span>
          <span>{{ formData.code_disc_prm | value | formatMoney }}</span>
        </div>
        <div class="tr">
          <span>MIB {{ formData.mib_pct }}%</span>
          <span>{{ formData.mib_vl | value | formatMoney }}</span>
        </div>
        <div
          v-if="formData.class_id == 14"
          class="tr">
          <span>Manual Discount</span>
          <span>{{ formData.spec_disc_prm | value | formatMoney }}</span>
        </div>
        <div
          v-else
          class="tr">
          <span>IA Levy</span>
          <span>{{ formData.ia_levy_vl | value | formatMoney }}</span>
        </div>
      </div> -->
      <!--      <promo-code-->
      <!--        :codeType="codeType"-->
      <!--        :orderId="orderId"-->
      <!--        :applyCode="formData.code"-->
      <!--        :customerId="formData.customer_id"-->
      <!--        @apply="handlerApplyCode" />-->
      <code-select
        v-if="formData.use_code!=0"
        :orderId="orderId"
        :isQuote="false"
        :isSpon="isSpon"
        :customerId="formData.customer_id"
        :customer="formData.customer"
        :isUser="true"
        :useCode="formData.use_code"
        @check-code="handlerApplyCode"></code-select>
      <div class="total-box">
        <span>Total</span>
        <span
          :style="{ fontSize: cssFontSize(formData.amount, 170, 24) }"
          class="amount">{{ formData.amount | formatMoney(2, true) }}</span>
      </div>
    </div>
    <plan-dialog
      ref="plan-dialog"
      :planInfo="formData.quote_coverage_list" />
  </section>
  
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import PlanDialog from '@/views/quoting/dialogs/plan-dialog'
import {applyOrderCode, verifyPromoCode} from '@/api/order'
import CodeSelect from '@/views/components/code-select'
import PlanQuoteInfo from '@/views/components/plan-quote-info'
import {mapState} from 'vuex'

export default {
  name: 'PlanInfo',
  components: {
    PlanDialog,
    // PromoCode,
    PlanQuoteInfo,
    CodeSelect
  },
  mixins: [MixinOptions, MixinFormat],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    codeType: {
      type: String,
      default: ''
    },
    customerId: {
      type: [String,Number],
      default: ''
    },
  },
  data() {
    return {
      formData: {
        code_disc_prm: '',
        code_disc_pct: '',
      },
      code: '',
      isFirst:true
    }
  },
  computed: {
    ...mapState('coupon', ['selectCode']),
    orderId() {
      return this.formData.id
    },
    isSpon(){
      let { quote_coverage_list} = this.formData||{}
      let {plan_info={}} =quote_coverage_list||{}
      let {is_sponsor=''} = plan_info||{}
      return is_sponsor==1
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        this.formData = JSON.parse(JSON.stringify(val))
      }
    }
  },
  methods: {
    handlerApplyCode(data) {
      // this.formData = Object.assign(this.formData, data)
      // this.$emit('apply', data)
      this.network().applyOrderCode()
    },
    planClick() {
      this.$refs['plan-dialog'].changeDialog()
    },
    network() {
      return {
        verifyPromoCode: async () => {
          const { data } = await verifyPromoCode({
            customer_id: this.formData.customer_id,
            code: this.code
          })
          if(data.code == 1000) {
            this.network().applyOrderCode()
          }
        },
        applyOrderCode: async () => {
          let {selectCode, code, coupon} = this.selectCode||{}
          let params = {}
          if(coupon&&coupon.selectCode==1)params.coupon_code = coupon&&coupon.coupon_code
          if(code&&code.selectCode==2)params.code = code&&code.code

          const { data } = await applyOrderCode({
            order_id: this.orderId,
            customer_id: this.formData.customer_id,
            ...params
          })
          // this.formData.amount = data.amount
          this.formData = Object.assign(this.formData, data)
          this.$emit('apply', this.formData )
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.plan-info-container {
    .card {
     width: 250px;
    .company-logo {
      display: block;
      // width: 78px;
      height: 42px;
      img {
        // width: 100%;
        height: 100%;
      }
    }
    .label {
      display: block;
      margin: 10px 0;
      font-size: 16px;
      line-height: 19px;
      font-weight: bold;
    }
    .total-box {
      margin: 15px -15px -15px -15px;
      padding: 15px;
      background: #ecf5ff;
      span {
        display: block;
        color: #616266;
        font-size: 14px;
      }
      .amount {
        font-size: 24px;
        color: #409eff;
        font-weight: bold;
      }
    }
    }
}
</style>